import Button from '@mui/material/Button';
import Link from 'next/link';
import styled from 'styled-components';

const StyledA = styled.a<{ $isDisabled: boolean }>`
  color: ${props => props.theme.palette.secondary.main};

  ${props =>
    props.$isDisabled &&
    `
  pointer-events: none;
  cursor: default;
  `}
`;

interface Props {
  children: React.ReactNode;
  /** TODO - This is only optional since we have created a short term hack for the CSS issue.
   * We want to use the same buttons as the Links/AppLinks but without the Next routing.
   * Therefore, we are passing an onclick method to the button rather than using the next routing.
   * I may be able to come up with a better solution, but we are on a deadline.
   * Once the pages are being served up by Next, we shouldn't run into these issues.
   */
  href?: string;
  variant?: 'text' | 'outlined' | 'contained';
  openInNewTab?: boolean;
  isButtonLink?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

export const AppLinkRoot = ({
  // TODO - Remove optional option
  href = undefined,
  children,
  openInNewTab = false,
  isButtonLink = false,
  disabled = false,
  variant = 'outlined',
  // Can only be used when isButtonLink. Otherwise, pass in the href.
  onClick = () => null,
}: Props) => {
  return isButtonLink ? (
    <Button
      href={href ?? ''}
      target={openInNewTab ? '_blank' : ''}
      variant={variant}
      color="secondary"
      fullWidth
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </Button>
  ) : (
    // The onclick method cannot be applied when using the Text Link. You have to pass in an href instead.
    // the Href must be a path, and cannot be an empty string. An empty string will result in a link that
    // references the page you are on.
    <StyledA href={href} target={openInNewTab ? '_blank' : ''} $isDisabled={disabled}>
      {children}
    </StyledA>
  );
};

/** Nextjs linking */
export const AppLink = ({
  href,
  children,
  openInNewTab = false,
  variant = 'outlined',
  isButtonLink = false,
  disabled = false,
}: Omit<Props, 'onClick'>) => {
  return (
    //TODO - remove undefined href.
    <Link href={href ?? ''} passHref={true}>
      <AppLinkRoot
        href={href}
        openInNewTab={openInNewTab}
        isButtonLink={isButtonLink}
        disabled={disabled}
        variant={variant}
      >
        {children}
      </AppLinkRoot>
    </Link>
  );
};
